import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";

const VerwijderResultatenModal = ({ open, onClose, onConfirm, isLoading, showError, error }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "Figtree",
          fontWeight: 600,
          color: "#0F3A58",
          fontSize: "24px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <DeleteIcon sx={{ color: "#E54344" }} />
        {t("Check verwijderen")}
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText
          sx={{
            fontFamily: "Figtree",
            color: "#2D2D2D",
            fontSize: "16px",
            lineHeight: "180%",
          }}
        >
          {t("confirmDeleteCheck")}

        </DialogContentText>
        
        {showError && error && (
          <div
            style={{
              marginTop: "16px",
              padding: "12px",
              backgroundColor: "#FFEBEE",
              border: "1px solid #E54344",
              borderRadius: "8px",
              color: "#E54344",
              fontSize: "14px",
              fontFamily: "Figtree",
              fontWeight: 500,
            }}
          >
            Error: {error}
          </div>
        )}
      </DialogContent>
      
      <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: "12px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          sx={{
            borderRadius: "40px",
            textTransform: "none",
            fontFamily: "Figtree",
            fontWeight: 500,
            borderColor: "#D1D5DB",
            color: "#6B7280",
            "&:hover": {
              borderColor: "#9CA3AF",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          {t("Annuleren")}
        </Button>
        
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isLoading}
          sx={{
            backgroundColor: "#E54344",
            borderRadius: "40px",
            textTransform: "none",
            fontFamily: "Figtree",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#DC2626",
            },
          }}
        >
          {t("Verwijderen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerwijderResultatenModal;